import { Box, Typography } from "@mui/material";
import { type ReactNode } from "react";

interface PageHeaderProps {
  /** Page title — rendered as <h2> with the standard large-bold treatment. */
  title: ReactNode;
  /** One-line subtitle explaining the page. Optional. */
  description?: ReactNode;
  /** Action buttons / toggles shown in the right-aligned slot (Import/Export/Add buttons). */
  actions?: ReactNode;
}

/**
 * Standard list-page / detail-page header.
 * Stacks vertically on mobile, splits into title-left / actions-right at sm+.
 * Used across every list page (Customers, Prospects, Contacts, Tasks, Invoices, etc.).
 */
export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { sm: "center" },
        justifyContent: { sm: "space-between" },
      }}
    >
      <Box>
        <Typography component="h2" sx={{ fontSize: "1.5rem", fontWeight: 700, color: "text.primary" }}>
          {title}
        </Typography>
        {description && <Typography sx={{ color: "text.secondary" }}>{description}</Typography>}
      </Box>
      {actions && (
        <Box sx={{ mt: { xs: 2, sm: 0 }, display: "flex", alignItems: "center", gap: 1 }}>{actions}</Box>
      )}
    </Box>
  );
}
